import UiVirtualScroll from '../../../../../../../../../components/VirtualScroll';
import { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip, Modal, Button } from 'react-bootstrap';
import moment from 'moment/moment';
import {
  faAward,
  faUserMinus,
  faThumbsUp,
  faCircleQuestion,
  faCalculator,
  faVolumeHigh,
  faVolumeSlash,
  faRetweet,
  faUpload,
  faCameraSlash,
  faClock,
  faLanguage,
  faLock,
  faMessagesQuestion,
  faChartArea,
  faSort,
  faShuffle,
  faEye,
  faEyeSlash,
  faCalendarDays,
  faEraser,
  faLockA,
  faAlarmExclamation,
  faTimer
} from '@fortawesome/pro-solid-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useAssignmentContext } from '../../../../../../../context';
import {
  useUnassignStudentsMutation,
  useSetAssignmentToReviewMutation
} from '../../../../../../../../../features/authentication/assignmentApislice';
import PropTypes from 'prop-types';
import FloatingMenu from '../../../../../../../../../components/floatingMenu/floatingMenu';
import CustomToast from '../../../../../../../../../components/Toast/index';
import ConfirmUnassignImg from '../../../../../../../../../assets/images/confirmUnassign.png';
import StudentClipboardImg from '../../../../../../../../../assets/images/studentClipboard.png';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import TableSkeleton from '../../../../../../../../../components/SkeletonLoader/TableSkeleton';
import ActivityTypes from '../../../../../../../../../enums/activityTypes';
import { ActivityUtils } from '../../../../../../../../activitySearch/activityUtils';
import { validateStudentsForReviewMode } from '../../../../../../../../../utils/validateStudentsForReviewMode';

function generateAssignmentDetails(activityType, assignmentOptions, index, optionsPerRow) {
  let assignmentDetails = [];

  switch (assignmentOptions.mode) {
  case 0:
  case 4:
  case 6:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
            {ActivityUtils.getActivityName(activityType)} Mode: Open
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#48E0B2', backgroundColor: '#E3FFF6' }}>
            Open
        </div>
      </OverlayTrigger>
    );
    break;
  case 2:
  case 7:
  case 8:
  case 9:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
            {ActivityUtils.getActivityName(activityType)} Mode: Quiz
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#A29BFE', backgroundColor: '#E9E9FD' }}>
            Quiz
        </div>
      </OverlayTrigger>
    );
    break;
  case 1:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
            {ActivityUtils.getActivityName(activityType)} Mode: Locked
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#F84646', backgroundColor: '#FFE3E3' }}>
            Locked
        </div>
      </OverlayTrigger>
    );
    break;
  case 3:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
            {ActivityUtils.getActivityName(activityType)} Mode: Review
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#FFA800', backgroundColor: '#FFF4E3', fontSize: '1em' }}>
            Review
        </div>
      </OverlayTrigger>
    );
    break;
  case 5:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
            {ActivityUtils.getActivityName(activityType)} Mode: Offline
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#969696', backgroundColor: '#F0F2F8' }}>
            Offline
        </div>
      </OverlayTrigger>
    );
    break;
  case 11:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
            {ActivityUtils.getActivityName(activityType)} Mode: GradeCam
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#82A9E2', backgroundColor: '#E4EFFC' }}>
            GradeCam
        </div>
      </OverlayTrigger>
    );
    break;
  }

  switch (assignmentOptions.mode) {
  case 2:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentModeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentModeOption-${index}`} className="custom-tooltip">
              Show grade upon completion of quiz
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#E3FFF6' }}>
          <FontAwesomeIcon icon={faEye} color="#48E0B2" />
        </div>
      </OverlayTrigger>
    );
    break;
  case 6:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentModeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentModeOption-${index}`} className="custom-tooltip">
              Automatically lock questions
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
          <FontAwesomeIcon icon={faLockA} color="#F84646" />
        </div>
      </OverlayTrigger>
    );
    break;
  case 8:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentModeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentModeOption-${index}`} className="custom-tooltip">
              Allow changes to answers
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFF2F7' }}>
          <FontAwesomeIcon icon={faEraser} color="#FD79A8" />
        </div>
      </OverlayTrigger>
    );
    break;
  case 9:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentModeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentModeOption-${index}`} className="custom-tooltip">
            {'Don\'t show grade upon completion of quiz'}
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
          <FontAwesomeIcon icon={faEyeSlash} color="#F84646" />
        </div>
      </OverlayTrigger>
    );
    break;
  }

  // Past Due
  if (assignmentOptions.timedOut)
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentTimedOut-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentTimedOut-${index}`} className="custom-tooltip">
            Past due
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
          <FontAwesomeIcon icon={faAlarmExclamation} color="#F84646" />
        </div>
      </OverlayTrigger>
    );

  // From/To
  if (assignmentOptions.mode == 4 || assignmentOptions.availability) {
    var dateTimeOptions = {
      month: '2-digit',
      day: '2-digit',
      year: '2-digit',
      hour: 'numeric',
      minute: '2-digit'
    };
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentTimedOut-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentTimedOut-${index}`} className="custom-tooltip">
            From/To
            <br />
            {`${new Date(assignmentOptions.availability.startDate).toLocaleString(
              'en-US',
              dateTimeOptions
            )} - ${new Date(assignmentOptions.availability.endDate).toLocaleString(
              'en-US',
              dateTimeOptions
            )}`}
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#D9F6FF' }}>
          <FontAwesomeIcon icon={faCalendarDays} color="#09BCF3" />
        </div>
      </OverlayTrigger>
    );
  }
  // Timed
  if (assignmentOptions.timeLimit) {
    var duration = moment.duration(assignmentOptions.timeLimit);
    assignmentDetails.push(
      <OverlayTrigger
        key={`timed-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-timedOption-${index}`} className="custom-tooltip">
            {ActivityUtils.getActivityName(activityType)} is timed:{' '}
            {`${duration.hours() > 0 ? duration.hours() + 'h' : ''} ${duration.minutes()}m`}
          </Tooltip>
        }>
        <div className="assignmentOptions assignmentOptionsIcon">
          <FontAwesomeIcon color="#82A9E2" icon={faTimer} />
        </div>
      </OverlayTrigger>
    );
  }
  // On screen calculator
  if (assignmentOptions.onScreenCalculator) {
    if (assignmentOptions.calculatorType == 1) {
      assignmentDetails.push(
        <OverlayTrigger
          key={`calculatorOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-calculatorOption-${index}`} className="custom-tooltip">
              A 4 Function Calculator is available on screen for this {ActivityUtils.getActivityName(activityType).toLowerCase()}
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: 'lightpink' }}>
            <FontAwesomeIcon color="red" icon={faCalculator} />
          </div>
        </OverlayTrigger>
      );
    } else if (assignmentOptions.calculatorType == 2) {
      assignmentDetails.push(
        <OverlayTrigger
          key={`calculatorOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-calculatorOption-${index}`} className="custom-tooltip">
              A Scientific Calculator is available on screen for this {ActivityUtils.getActivityName(activityType).toLowerCase()}
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: '#E4EFFC' }}>
            <FontAwesomeIcon color="#82A9E2" icon={faCalculator} />
          </div>
        </OverlayTrigger>
      );
    }
  }

  // Randomized questions
  if (assignmentOptions.questionsRandomized)
    assignmentDetails.push(
      <OverlayTrigger
        key={`randomizedOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-randomizedOption-${index}`} className="custom-tooltip">
            {activityType == ActivityTypes.FlashCard ? 'Vocabularies' : 'Questions'} are Randomized
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFF2F7' }}>
          <FontAwesomeIcon color="#FD79A8" icon={faShuffle} />
        </div>
      </OverlayTrigger>
    );

  // Re-takes enabled
  if (assignmentOptions.retakes)
    assignmentDetails.push(
      <OverlayTrigger
        key={`retakeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-retakeOption-${index}`} className="custom-tooltip">
            Retakes Enabled
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#F2E5FF' }}>
          <FontAwesomeIcon icon={faRetweet} color="#9E5CDF" />
        </div>
      </OverlayTrigger>
    );

  // Text to speech enabled
  if (assignmentOptions.textToSpeech) {
    assignmentDetails.push(
      <OverlayTrigger
        key={`textToSpeechOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-textToSpeechOption-${index}`} className="custom-tooltip">
            Text-to-Speech Enabled
          </Tooltip>
        }>
        <div className='assignmentOptions bg-lightgreen'>
          <FontAwesomeIcon icon={faVolumeHigh} className='success-icon-btn' />
        </div>
      </OverlayTrigger>
    );

    // Text to speech disabled
  } else {
    assignmentDetails.push(
      <OverlayTrigger
        key={`textToSpeechOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-textToSpeechOption-${index}`} className="custom-tooltip">
            Text-to-Speech Disabled
          </Tooltip>
        }>
        <div className='assignmentOptions bg-lightred'>
          <FontAwesomeIcon icon={faVolumeSlash} className='danger-icon-btn' />
        </div>
      </OverlayTrigger>
    );
  }

  // Time on task
  if (assignmentOptions.timeOnTask)
    assignmentDetails.push(
      <OverlayTrigger
        key={`timeOnTaskOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-timeOnTaskOption-${index}`} className="custom-tooltip">
            The amount of time the student takes answering questions will be tracked
            <br />
            {`Maximum Time Per Question: ${assignmentOptions.timeOnTask}`}
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#D9F6FF' }}>
          <FontAwesomeIcon icon={faClock} color="#09BCF3" />
        </div>
      </OverlayTrigger>
    );

  // Photomath blocker
  if (assignmentOptions.photomathBlocker)
    assignmentDetails.push(
      <OverlayTrigger
        key={`photomathBlockerOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-photomathBlockerOption-${index}`} className="custom-tooltip">
            Photomath Blocker Enabled
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
          <FontAwesomeIcon icon={faCameraSlash} color="#F84646" />
        </div>
      </OverlayTrigger>
    );

  // Language change
  if (assignmentOptions.allowLanguageChange)
    assignmentDetails.push(
      <OverlayTrigger
        key={`languageChangeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-languageChangeOption-${index}`} className="custom-tooltip">
            The student will be allowed to change the display language while taking this {ActivityUtils.getActivityName(activityType).toLowerCase()}
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#E3FFF6' }}>
          <FontAwesomeIcon icon={faLanguage} color="#48E0B2" />
        </div>
      </OverlayTrigger>
    );

  // Browser lockdown
  if (assignmentOptions.browserLockdown)
    assignmentDetails.push(
      <OverlayTrigger
        key={`browserLockOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-browserLockOption-${index}`} className="custom-tooltip">
            The student will not be allowed have other browser tabs or windows open while taking
            this {ActivityUtils.getActivityName(activityType).toLowerCase()}.
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
          <FontAwesomeIcon icon={faLock} color="#F84646" />
        </div>
      </OverlayTrigger>
    );

  // Student Upload File
  if (assignmentOptions.studentUploadFiles)
    assignmentDetails.push(
      <OverlayTrigger
        key={`studentFileUploadOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-studentFileUploadOption-${index}`} className="custom-tooltip">
            Student is allowed to upload files
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#E4EFFC' }}>
          <FontAwesomeIcon icon={faUpload} color="#82A9E2" />
        </div>
      </OverlayTrigger>
    );

  let detailRows = [];
  var keyIndex = 0;
  do {
    detailRows.push(
      <div
        key={`optionRow${index}${keyIndex}`}
        className={`d-flex flex-row ${keyIndex > 0 ? 'mt-2' : ''}`}>
        {assignmentDetails.splice(0, optionsPerRow).map((assignmentOption) => {
          return assignmentOption;
        })}
      </div>
    );
    keyIndex++;
  } while (assignmentDetails.length > 0);

  return <div className="d-flex flex-column">{detailRows}</div>;
}

function AssignedTable({
  assignedStudents,
  setAssignedStudents,
  selectedClassFilterIds,
  refetchCallback,
  dataStatus,
  assignmentHasCRQuestions,
  isIncludeCRQuestion,
  showAssignmentSettings,
  setShowAssignmentSettings,
  assignmentRetakeEnabled,
  isLoading
}) {
  const [showConfirmUnassignModal, setShowConfirmUnassignModal] = useState(false);
  const sortByAscending = useRef(true);
  const sortResultsBy = useRef('sort-lastName');
  const navigate = useNavigate();
  const { assignmentId } = useAssignmentContext();
  const [setAssignmentToReview, setAssignmentToReviewResults] = useSetAssignmentToReviewMutation();
  const [unassignStudents, unassignStudentsResult] = useUnassignStudentsMutation();
  const [showConfirmReviewModal, setShowConfirmReviewModal] = useState(false);
  const { activityType = ActivityTypes.Assignment } = useParams();
  
  const [floatingMenuButtons, setFloatingMenuButtons] = useState([
    {
      id: 1,
      name: 'CR Grading',
      tooltip: `Grade CR questions for this ${ActivityUtils.getActivityName(activityType).toLowerCase()}`,
      icon: <FontAwesomeIcon icon={faAward} />,
      disabled: true,
      hide: activityType == ActivityTypes.FlashCard
    },
    {
      id: 2,
      name: `Unassign ${ActivityUtils.getActivityName(activityType)}`,
      tooltip: `This option allows you to unassign the Original ${ActivityUtils.getActivityName(activityType)}.`,
      icon: <FontAwesomeIcon icon={faUserMinus} />,
      disabled: true
    },
    {
      id: 3,
      name: 'Set to Review Only (Includes any Retakes)',
      tooltip: 'Set to Review Only (Includes any Retakes)',
      icon: <FontAwesomeIcon icon={faThumbsUp} />,
      disabled: true,
      hide: activityType == ActivityTypes.FlashCard
    }
    , {
      id: 4,
      name: `${ActivityUtils.getActivityName(activityType)} Settings`,
      tooltip: `${ActivityUtils.getActivityName(activityType)} Settings`,
      icon: <FontAwesomeIcon icon={faGear} />,
      disabled: false,
      isEnabled: showAssignmentSettings
    }
  ]);

  const handleClick = (floatId) => {
    switch (floatId) {
    case 1:
      handleCrGrading();
      break;
    case 2:
      setShowConfirmUnassignModal(true);
      break;
    case 3:{
      const selectedResults = assignedStudents.filter((item) => item.isChecked == true);
      const validationResult = validateStudentsForReviewMode(selectedResults);

      if (!validationResult.isValid) {
        CustomToast(validationResult.message, 'warning');
        return;
      }
      setShowConfirmReviewModal(true);
      break;
    }
    case 4:
      setShowAssignmentSettings(!showAssignmentSettings);
      updateSettings(!showAssignmentSettings);
      break;
    }
  };

  const updateSettings = (isEnabled) =>{
    let tempArray = [...floatingMenuButtons];
    tempArray[3].isEnabled = isEnabled;
    setFloatingMenuButtons(tempArray);
  };

  useEffect(() => {
    if (assignmentHasCRQuestions) {
      let tempArray = [...floatingMenuButtons];
      tempArray[0].disabled = isIncludeCRQuestion ? false : true;
      setFloatingMenuButtons(tempArray);
    }
  }, []);

  const handleCrGrading = () => {
    navigate(`/assignments/${assignmentId}/grade_constructiveResponses`);
  };

  const handleAssignmentChecked = (e) => {
    const { name, checked } = e.target;
    let tempAssignmentResults = [];

    if (name === 'allselect') {
      tempAssignmentResults = assignedStudents.map((item) => {
        return { ...item, isChecked: checked };
      });
    } else {
      tempAssignmentResults = assignedStudents.map((item) =>
        item.studentId == name ? { ...item, isChecked: checked } : item
      );
    }
    setAssignedStudents(tempAssignmentResults);

    const hasSelectedStudents = tempAssignmentResults.some(
      (student) => student.isChecked === true
    );

    let tempButtons = [...floatingMenuButtons];
    tempButtons = tempButtons.map((button) => {
      if (button.id === 1) {
        return button;
      }

      if (button.id === 4) {
        return button;
      }

      if (button.id === 3) {
        return {
          ...button,
          disabled: !hasSelectedStudents || !assignmentRetakeEnabled
        };
      }

      return {
        ...button,
        disabled: !hasSelectedStudents
      };
    });
    setFloatingMenuButtons(tempButtons);
  };

  async function handleSetAssignmentToReview() {
    try {
      var selectedStudentIds = assignedStudents
        .filter((s) => s.isChecked == true)
        .map((s) => s.studentId);
      var reviewResult = await setAssignmentToReview({
        originalAssignmentId: assignmentId,
        studentIds: selectedStudentIds
      }).unwrap();
      setShowConfirmReviewModal(false);
      if (reviewResult.students.length == selectedStudentIds.length) {
        CustomToast(`Original and retake ${ActivityUtils.getActivityName(activityType).toLowerCase()}s set to review`, 'success');
      } else if(reviewResult.students.length < selectedStudentIds.length){
        CustomToast(reviewResult.message, 'warning');
      }
      refetchCallback();
    } catch {
      CustomToast('Something went wrong trying to set assignment(s) to review', 'error');
    }
  }

  const handleAssignmentSort = (e) => {
    let sortedAssignmentResults = [...assignedStudents];
    if (e) sortByAscending.current = !sortByAscending.current;
    switch (sortResultsBy.current) {
    case 'sort-lastName':
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.studentLastName > b.studentLastName ? 1 : -1
      );
      break;
    case 'sort-firstName':
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.studentFirstName > b.studentFirstName ? 1 : -1
      );
      break;
    case 'sort-className':
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.className > b.className ? 1 : -1
      );
      break;
    case 'sort-status':
      sortedAssignmentResults = sortedAssignmentResults.sort(
        (a, b) => a.crAnsweredCount - b.crAnsweredCount
      );
      break;
    default:
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.studentLastName > b.studentLastName ? 1 : -1
      );
    }
    if (!sortByAscending.current) sortedAssignmentResults.reverse();

    setAssignedStudents(sortedAssignmentResults);
  };

  async function handleUnassignStudents() {
    try {
      var selectedStudents = assignedStudents
        .filter((s) => s.isChecked == true)
        .map((s) => s.studentId);

      await unassignStudents({ assignmentId: assignmentId, studentIds: selectedStudents }).unwrap();
      refetchCallback();

      let tempButtons = [...floatingMenuButtons];
      tempButtons = tempButtons.map((button) => {
        return button.id == 1 ? button : { ...button, disabled: true };
      });
      setFloatingMenuButtons(tempButtons);
      setShowConfirmUnassignModal(false);

      CustomToast(
        `${selectedStudents.length} student${selectedStudents.length === 1 ? ' has' : 's have'
        } been removed from the ${ActivityUtils.getActivityName(activityType).toLowerCase()}`,
        'success'
      );
    } catch {
      CustomToast('Something went wrong trying to unassign the assignment', 'error');
    }
  }

  const reportNavigateHandler = (studentId, assignmentId, className, scoreUnansweredAsZero) => {
    navigate(`/assignments/${assignmentId}/${activityType}/manage_assign/reports/student_session_report?studentId=${studentId}&incompleteScoring=${scoreUnansweredAsZero}`, {
      state: { className: className }
    });
  };

  return (
    <>
      <div className="custom-table table-responsive">
        {!isLoading ? (
          <UiVirtualScroll rowHeight={60} height="400px">
            <table className="table">
              <thead>
                <tr>
                  <th>
                    {assignedStudents?.length > 0 && 
                      <input
                        type="checkbox"
                        className="form-check-input"
                        value=""
                        id="flexCheckDefault"
                        name="allselect"
                        checked={assignedStudents?.filter((item) => item?.isChecked !== true).length < 1}
                        onChange={handleAssignmentChecked}
                        defaultChecked={false}
                      />
                    }
                  </th>
                  <th>
                Last Name
                    <button
                      className="sort-btn"
                      id="sort-lastName"
                      onClick={(e) => {
                        sortResultsBy.current = e.target.id;
                        handleAssignmentSort(e);
                      }}>
                      <FontAwesomeIcon icon={faSort} />
                    </button>
                  </th>
                  <th>
                First Name
                    <button
                      className="sort-btn"
                      id="sort-firstName"
                      onClick={(e) => {
                        sortResultsBy.current = e.target.id;
                        handleAssignmentSort(e);
                      }}>
                      <FontAwesomeIcon icon={faSort} />
                    </button>
                  </th>
                  <th>
                Class
                    <button
                      className="sort-btn"
                      id="sort-className"
                      onClick={(e) => {
                        sortResultsBy.current = e.target.id;
                        handleAssignmentSort(e);
                      }}>
                      <FontAwesomeIcon icon={faSort} />
                    </button>
                  </th>
                  <th>
                Status
                    <button
                      className="sort-btn"
                      id="sort-status"
                      onClick={(e) => {
                        sortResultsBy.current = e.target.id;
                        handleAssignmentSort(e);
                      }}>
                      <FontAwesomeIcon icon={faSort} />
                    </button>
                  </th>
                  <th>
                Details
                    <OverlayTrigger
                      key={'detailstooltip'}
                      placement="left"
                      overlay={
                        <Tooltip className="initial-assignment-tooltip">
                          <div>
                            <div>
                              <p>
                            The <strong>Details</strong> indicates {ActivityUtils.getActivityName(activityType).toLowerCase()} mode, whether
                            Text-to-Speech is enabled or disabled, and whether the {ActivityUtils.getActivityName(activityType).toLowerCase()} is
                            randomized. An R indicates the {ActivityUtils.getActivityName(activityType).toLowerCase()} is randomized. If the
                            Text-to-Speech icon has a red cross through it, that indicates that
                            Text-to-Speech is disabled.
                              </p>
                              <p>
                            The <strong>{ActivityUtils.getActivityName(activityType)} Mode</strong> indicates how students can interact
                            with the {ActivityUtils.getActivityName(activityType).toLowerCase()}.
                              </p>
                              <ul>
                                <li>
                                  <strong>Open</strong>: allows students full access to all questions,
                              with all available feedback.
                                </li>
                                {activityType == ActivityTypes.Assignment && 
                                <>
                                  <li>
                                    <strong>Quiz</strong>: students can answer the questions but do not
                              get any feedback.
                                  </li>
                                  <li>
                                    <strong>Offline</strong>: Locked to students who work on the
                                    {ActivityUtils.getActivityName(activityType).toLowerCase()} offline. Student answers uploaded by the teacher. Only
                              available if the {ActivityUtils.getActivityName(activityType).toLowerCase()} contains just multiple choice questions.
                                  </li>
                                </>
                                }
                              </ul>

                              <p>
                            The <strong>Availability Options</strong> controls when a student has
                            access to the {ActivityUtils.getActivityName(activityType).toLowerCase()}
                              </p>
                              <ul>
                                <li>
                                  <strong>Always:</strong> allows students full access to all questions
                              at all times.
                                </li>
                                <li>
                                  <strong>From/To:</strong> allows students to work on the {ActivityUtils.getActivityName(activityType).toLowerCase()}
                              within a date and time range.
                                </li>
                              </ul>
                              {activityType == ActivityTypes.Assignment &&
                              <p>
                            The <strong>Timed</strong> option allows the student to work on an
                                {ActivityUtils.getActivityName(activityType).toLowerCase()} for the specified amount of time. Timer starts when the
                            student opens the {ActivityUtils.getActivityName(activityType).toLowerCase()}.
                              </p>
                              }
                              <br />
                            </div>
                          </div>
                        </Tooltip>
                      }>
                      <FontAwesomeIcon className='mx-2' icon={faCircleQuestion} color="#88CBF1" />
                    </OverlayTrigger>
                  </th>
                  {activityType == ActivityTypes.Assignment && <th></th>}
                </tr>
              </thead>
              <tbody>
                {dataStatus.isError && (
                  <tr>
                    <td colSpan="7" style={{ textAlign: 'center' }}>
                      <button
                        style={{
                          color: '#F84646',
                          fontSize: '1.15rem',
                          border: 'none',
                          background: 'none'
                        }}
                        onClick={() => refetchCallback()}>
                    There was an error getting the data. Click to try again
                      </button>
                    </td>
                  </tr>
                )}
                {!isLoading &&
              (assignedStudents.length == 0) && (
                  <tr>
                    <td colSpan="7">
                      <div
                        className="d-flex align-items-end justify-content-center text-align-center"
                        style={{
                          backgroundImage: `url(${StudentClipboardImg})`,
                          backgroundRepeat: 'no-repeat',
                          height: '130px',
                          backgroundPositionX: 'center'
                        }}>
                        {assignedStudents.length == 0 ? (
                          <span>There are no students assigned to this {ActivityUtils.getActivityName(activityType).toLowerCase()}</span>
                        ) : (
                          <span>{`There are no assigned students within the selected class${selectedClassFilterIds.length === 1 ? '' : 'es'
                          }`}</span>
                        )}
                      </div>
                    </td>
                  </tr>
                )}

                {dataStatus.isSuccess &&
              assignedStudents.map((item, index) => {
                let bestScore = 0;
                if (item.retakeResults) {
                  let retakes = [...item.retakeResults];
                  retakes
                    .sort(
                      (a, b) =>
                        a.retriesAsNoCreditScore?.percent - b.retriesAsNoCreditScore?.percent
                    )
                    .reverse();
                  bestScore = retakes[0]?.retriesAsNoCreditScore;
                  if (item.retriesAsNoCreditScore?.percent > bestScore?.percent)
                    bestScore = item.retriesAsNoCreditScore;
                }

                return (
                  <tr key={`assignedStudentRow_${index}`}>
                    <td>
                      <input
                        type="checkbox"
                        value=""
                        name={item.studentId}
                        checked={item?.isChecked || false}
                        onChange={handleAssignmentChecked}
                        className="form-check-input"
                        id={`flexCheckDefault${item.assignmentId}`}
                      />
                    </td>
                    <td>{item.studentLastName}</td>
                    <td>{item.studentFirstName}</td>
                    <td>{item.className}</td>
                    <td>
                      <div className={`assignmentStatus ${(activityType == ActivityTypes.Assignment ? item.dateStarted : item.dateCompleted) ? 'started' : 'notStarted'}`}>
                        {activityType == ActivityTypes.Assignment ? (item.dateStarted ? 'Started' : 'Not Started') : (item.dateCompleted ? 'Completed' : 'Incomplete')}
                      </div>
                    </td>

                    <td>{generateAssignmentDetails(activityType, item.assignmentOptions, index, 4)}</td>
                    {activityType == ActivityTypes.Assignment &&
                    <td>
                      <div className="d-flex flex-row justify-content-end">
                        <div className='action-btns'>
                          <OverlayTrigger
                            key={`reponsesReport-${index}`}
                            placement="top"
                            overlay={
                              <Tooltip
                                id={`tooltip-reponsesReport-${index}`}
                                className="custom-tooltip">
                              Responses
                              </Tooltip>
                            }>
                            <button
                              onClick={() =>
                                item.dateStarted
                                  ? navigate(
                                    `/responses/${item.assignmentId}/${activityType}/${item.studentId}`
                                  )                                
                                  : ''
                              }
                              className='mx-2'>
                              <FontAwesomeIcon icon={faMessagesQuestion} color={!item.dateStarted && '#969696'} />
                            </button>
                          </OverlayTrigger>

                          <OverlayTrigger
                            key={`studentSessionReport-${index}`}
                            placement="top"
                            overlay={
                              <Tooltip
                                id={`tooltip-studentSessionReport-${index}`}
                                className="custom-tooltip">
                              Student Session Report
                              </Tooltip>
                            }>
                            <button
                              onClick={() =>
                                item.dateStarted
                                  ? reportNavigateHandler(
                                    item.studentId,
                                    item.assignmentId,
                                    item.className,
                                    false
                                  )
                                  : ''
                              }>
                              <FontAwesomeIcon icon={faChartArea} color={!item.dateStarted && '#969696'} />
                            </button>
                          </OverlayTrigger>
                        </div>
                      </div>
                    </td>
                    }
                  </tr>
                );
              })}
              </tbody>
            </table>
          </UiVirtualScroll>
        ):(
          <>
            {isLoading && (
              <TableSkeleton
                rowCount={4}
                colCount={5}
                skeletonClass='p-1'
              />
            )}
          </>
        )}
      </div>

      <div className="d-flex floating-menu-contained floating-menu-sticky justify-content-center">
        <FloatingMenu floatingButtons={floatingMenuButtons} onClick={handleClick} />
      </div>
      <Modal
        show={showConfirmUnassignModal}
        onHide={() => setShowConfirmUnassignModal(false)}
        size="lg"
        centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h1>Unassign {ActivityUtils.getActivityName(activityType)}</h1>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-center">
            <div
              style={{
                backgroundImage: `url(${ConfirmUnassignImg})`,
                backgroundRepeat: 'no-repeat',
                height: '120px',
                width: '140px'
              }}></div>

            <div style={{ fontSize: '1rem', fontWeight: '600' }}>
              Are you sure that you want to unassign the {ActivityUtils.getActivityName(activityType).toLowerCase()} from the checked students?
            </div>
            <div className="my-3 text-center">
              By unassigning from students who have started the {ActivityUtils.getActivityName(activityType).toLowerCase()}, you will no longer be
              able to view their results for this {ActivityUtils.getActivityName(activityType).toLowerCase()}.
            </div>

            <div className="d-flex flex-row justify-content-even w-50">
              <Button
                className="w-50"
                variant="castleGray"
                onClick={() => setShowConfirmUnassignModal(false)}>
                No
              </Button>
              <Button
                className="ms-3 w-50"
                variant="castleRed"
                onClick={() => handleUnassignStudents()}
                disabled={unassignStudentsResult.isLoading}>
                Yes
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showConfirmReviewModal}
        onHide={() => setShowConfirmReviewModal(false)}
        size="lg"
        centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h1>Confirm</h1>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-center">
            <div className="my-2" style={{ fontSize: '1rem', fontWeight: '600' }}>
              Are you sure you want to set the original {ActivityUtils.getActivityName(activityType).toLowerCase()} and retakes to review?
            </div>

            <div className="d-flex flex-row justify-content-even w-50">
              <Button
                className="w-50"
                variant="castleGray"
                onClick={() => setShowConfirmReviewModal(false)}>
                No
              </Button>
              <Button
                className="ms-3 w-50"
                variant="castleRed"
                onClick={() => handleSetAssignmentToReview()}
                disabled={setAssignmentToReviewResults.isLoading}>
                Yes
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

AssignedTable.propTypes = {
  assignedStudents: PropTypes.array.isRequired,
  setAssignedStudents: PropTypes.object,
  selectedClassFilterIds: PropTypes.array,
  refetchCallback: PropTypes.function,
  dataStatus: PropTypes.object,
  assignmentHasCRQuestions: PropTypes.bool,
  isIncludeCRQuestion: PropTypes.bool,
  showAssignmentSettings: PropTypes.bool,
  setShowAssignmentSettings: PropTypes.func,
  assignmentRetakeEnabled: PropTypes.bool,
  isLoading:PropTypes.bool
};

export default AssignedTable;
